export const getUrl = (url: string): string => {
  let sitecoreLanguage = window._THULEDATA.SitecoreLanguage;
  let relativeWithoutLanguage = url.split('domainplaceholder.com')[1];

  return relativeWithoutLanguage
    ? `/${sitecoreLanguage.toLowerCase()}${relativeWithoutLanguage}`
    : `/${sitecoreLanguage.toLowerCase()}`;
};
